import { FC } from "react";
import { Modal } from "components/Modal/Modal";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

interface AVGTimeResponseInfoProps {
  open: boolean;
  onClose: () => void;
}

export const AVGTimeResponseInfo: FC<AVGTimeResponseInfoProps> = ({
  open,
  onClose,
}) => {
  const responseTimeData = [
    {
      label: "Fast",
      range: "≤ 6 hours",
      description: "Quick response, high responsiveness",
    },
    {
      label: "Moderate",
      range: "> 6 and ≤ 24 hours",
      description: "Acceptable but could be improved",
    },
    {
      label: "Slow",
      range: "> 24 and ≤ 48 hours",
      description: "Noticeable delay, risk of learner drop-off",
    },
    {
      label: "Very Slow",
      range: "> 48 hours",
      description: "Very delayed response, needs attention",
    },
  ];

  return (
    <Modal open={open} onClose={onClose} title="AVG Time Response Information">
      <Box sx={{ p: 2 }}>
        <Typography variant="body1" gutterBottom>
          The following table explains the different response time categories
          and their implications:
        </Typography>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Label</TableCell>
              <TableCell>Range (Response Time)</TableCell>
              <TableCell>Description</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {responseTimeData.map((row) => (
              <TableRow key={row.label}>
                <TableCell>{row.label}</TableCell>
                <TableCell>{row.range}</TableCell>
                <TableCell>{row.description}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Box>
    </Modal>
  );
};
